//
// LayoutStrategy.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import EventDispatcher from "../../events/EventDispatcher";
import "../../lib";
import "../../models/BaseUIModel";
import "./LayoutStrategyType";

var LayoutStrategy = createModule("commons::LayoutStrategy", ["commons::PropertyOwner","commons::BaseModel","commons::BaseUIModel"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        layout: [0,1,1],
        getStrategyType: [4],
    },
    ,
    ,
]);
export default LayoutStrategy;
